export const apps = [
  // home: {
  //   name: "home",
  //   label: "Главная",
  //   icon: "ios-apps"
  // },


  {
    name: "home",
    label: "Главная",
    icon: "ios-apps"
  },
  {
    category: "catalog",
    name: "catalog",
    label: "Товары и услуги",
    icon: "ios-briefcase",
    children: [
      {
        category: "catalog",
        name: "catalog",
        label: "Номенклатура",
      },
      {
        category: "catalog",
        name: "warehouse",
        label: "Склад",
      },
      {
        category: "catalog",
        name: "product_order",
        label: "Движение товара",
      },
      {
        category: "catalog",
        name: "pdoc_actions",
        label: "Действия c товаром/услугой",
      },
      // {
      //   category: "catalog",
      //   name: "product_order_change_in_create",
      //   label: "Оприходование",
      // },
      // {
      //   name: "product_order_changes_out",
      //   label: "Списание",
      // },
      // {
      //   category: "catalog",
      //   name: "product_order_change_moving_create",
      //   label: "Перемещение товара",
      // },
      // {
      //   category: "catalog",
      //   name: "product_order_inventory_create",
      //   label: "Инвентаризация",
      // },

    ]
  },

  {
    name: "report",
    label: "Отчеты и аналитика",
    icon: "ios-podium",
    category: "report",
    children: [
      {
        category: "report",
        name: "business_graphics",
        label: "Бизнес графики",
      },
      // {
      //   category: "report",
      //   name: "seasonality",
      //   label: "Сезонность",
      // },
      // {
      //   category: "report",
      //   name: "products_and_service",
      //   label: "Товары и услуги",
      // },
      {
        category: "report",
        name: "period_report",
        label: "Отчет по кассам",
      }
    ]
  },


  // {
  //   name: "cash_shift",
  //   label: "Кассы и смены",
  //   icon: "ios-calculator",
  //   children: [
  //     {
  //       name: "cash",
  //       label: "Кассы",
  //     },
  //     {
  //       name: "shift",
  //       label: "Cмены",
  //     }
  //   ]
  // },
  {
    name: "operations",
    label: "Операции",
    icon: "ios-cash",
    category: "operations",
    children: [
      {
        name: "money_order",
        label: "Движение денег",
        category: "operations"
      },
      {
        name: "mdoc_actions",
        label: "Операции с деньгами",
        category: "operations"
      },
      {
        name: "fiscal_operations",
        label: "Фискальные операции",
        category: "operations"
      },
      {
        name: "product_operations",
        label: "Товарные операции",
        category: "operations"
      },

    ]
  },
  // {
  //   name: "money_order",
  //   label: "Движение денег",
  //   icon: "ios-cash"
  // },
  // {
  //   name: "product_order",
  //   label: "Движение товара",
  //   icon: "ios-repeat"
  // },

  {
    name: "company_main",
    label: "Компания",
    icon: "ios-people",
    children: [
      {
        name: "store",
        label: "Магазины",
        category: "company_main"
      },
      {
        name: "cash",
        label: "Кассы",
        category: "company_main"
      },
      {
        name: "auto_closing_shift",
        label: "Автозакрытие смены",
        category: "company_main"
      },

      {
        name: "user",
        label: "Сотрудники",
        category: "company_main"
      },
      {
        name: "company",
        label: "Профиль компании",
        category: "company_main"
      },

      // {
      //   name: "current_user",
      //   label: "Настройки пользователя",
      // }
    ]
  },
  {
    name: "counterpart",
    label: "Контрагенты",
    icon: "ios-person",
    children: [
      {
        name: "customer",
        label: "Клиенты",
        category: "counterpart"
      },
      {
        name: "supplier",
        label: "Поставщики",
        category: "counterpart"
      },
      {
        name: "debtor",
        label: "Должники",
        category: "counterpart",
      //   children: [
      //     {
      //       name: "debt_repayment",
      //       label: "Движение денег",
      //       category: "operations"
      // },
      //   ]
      }
    ]
  },


  {
    name: "payments",
    label: "Оплатаf",
    children: [
      {
        name: "payment",
        label: "Оплата",
        category: "payments"
      },
      {
        name: "license_keys",
        label: "Лицензионные ключи",
        category: "payments"
      },
      {
        name: "history_payment",
        label: "История платежей",
        category: "payments"
      }
    ]
  },
  {
    category: 'integrations',
    name: "integrations",
    label: "Модули и интеграции",
    children: [
      {
        name: "moduleLightPos",
        label: "Модуль Light POS",
      },
      {
        name: "moduleLightKassa",
        label: "Light Kassa",
      },
      {
        name: "moduleFiskal",
        label: "Модуль фискализации",
      },
    ]
  },
];



// WEBPACK FOOTER //
// ./src/apps.js